import DeleteModalContainer from './DeleteStockContainer';
import DeleteProductModalContainer from './DeleteProductContainer';
import AddProductContainer from './AddProductContainer';
import InventoryContainer from './InventoryContainer';
import OrderPageContainer from './OrderPageContainer';
import EditModalContainer from './EditModalContainer';
import LinkModalContainer from './LinkModalContainer';
import ViewMoreContainer from './ViewMoreContainer';
import AddStockContainer from './AddStockContainer';
import EditStockContainer from './EditStockContainer';
import CheckoutContainer from './CheckoutContainer';
import AddVariationMainContainer from './AddVariationMainContainer';
import SplitViewMoreContainer from './SplitViewMoreContainer';
import ActivityTrailContainer from './ActivityTrailContainer';
import UpdateQtyContainer from './UpdateQtyContainer';
import ViewMoreStockContainer from './ViewMoreStockContainer';
import AddRateCardMainContainer from './AddRateCardContainer';
import UpdateRateCardMainContainer from './UpdateRateCardContainer';
import AddBulkProductsContainer from './AddBulkProductsContainer';

export {
	InventoryContainer,
	OrderPageContainer,
	AddStockContainer,
	DeleteProductModalContainer,
	AddProductContainer,
	DeleteModalContainer,
	EditModalContainer,
	LinkModalContainer,
	ViewMoreContainer,
	EditStockContainer,
	CheckoutContainer,
	AddVariationMainContainer,
	SplitViewMoreContainer,
	UpdateQtyContainer,
	ActivityTrailContainer,
	AddBulkProductsContainer,
	AddRateCardMainContainer,
	UpdateRateCardMainContainer,
	ViewMoreStockContainer,
};
